import React from 'react';
import { Box, Image } from 'grommet';
import SkillDormLogo from 'assets/images/skilldormblacklogo.png';
import { home } from 'adminRoutes';
import { animate } from 'utils';
import ChangePasswordForm from 'components/forms/ChangePasswordForm';
// import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import NotificationModal from 'components/modals/NotificationModal';
import { signOut } from 'store/actions/auth';
import { useDispatch } from 'react-redux';

const ChangePassword = () => {
  const [successMessage, setSuccessMessage] = React.useState(null);
  const history = useHistory();
  const dispatch = useDispatch();

  return (
    <Box pad="medium" align="center" justify="center" height="100vh">
      <Box height="xsmall" width="small">
        <img src={SkillDormLogo} style={{ margin: '2.2rem 0 0 -.1rem' }} alt="" />
      </Box>
      <Box align="center" animation={animate({ type: 'slideUp' })}>
        <ChangePasswordForm setSuccessMessage={setSuccessMessage} />
      </Box>
      {successMessage && (
        <NotificationModal
          title="Password Changed"
          message={successMessage}
          status="success"
          iconHeight="80px"
          iconWidth="80px"
          actionText="Got it"
          actionFunc={() => {
            dispatch(signOut());
            history.replace(home);
          }}
        />
      )}
    </Box>
  );
};

export default ChangePassword;
